import React from 'react';
import { useParams } from 'react-router-dom';
import FormLayout from '../components/FormLayout';
import FormHeader from '../components/FormHeader';
import FinalStep from '../components/FinalStep';

const FinalStepPage: React.FC = () => {
  const { userId } = useParams<{ userId: string }>();

  return (
    <FormLayout>
      <FormHeader
        title="Create Your Password"
        subtitle="Complete your PRAIRI account setup"
      />

      <FinalStep userId={userId} />
    </FormLayout>
  );
};

export default FinalStepPage;
